export const AUTH_ROUTES = {
	AUTH: "/auth",
	ACCEPT_INVITE: "/auth/accept-invite",
} as const;
